import "./css/bootstrap.min.css";
import "./css/dashboard.css";
import "./css/site.css";

import React, { Component } from "react";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./configureStore";
import * as RoutesModule from "./routes";
import { rootSaga } from "./sagas";
import ExEnv from "exenv";
import ReduxToastr from "react-redux-toastr";
import Immutable from "seamless-immutable";
import { default as HttpInterceptors } from "./utils/http-interceptors";
import axios from "axios";
import { Helmet } from "react-helmet";

let routes = RoutesModule.routes;

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

const initialState = Immutable(window.initialReduxState);
const store = configureStore(history, Immutable(initialState));
store.runSaga(rootSaga);

const isDeveloping = process.env.NODE_ENV !== "production";
const restUri = window.location.hostname.split(".").slice(1).join(".");
const uriPort = isDeveloping
  ? process.env.REACT_APP_PORT
  : window.location.port;
const uriName = isDeveloping
  ? process.env.REACT_APP_HOST?.split(".")[0]
  : window.location.hostname.split(".")[0];

axios.defaults.baseURL = `https://${uriName}-api.${restUri}:${uriPort}`;

HttpInterceptors.setup(store, history);
function renderApp(store, routes, history) {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <div>
          <Helmet>
            <meta
              name="deklaracja-dostępności"
              content={`${window.location.protocol}//${window.location.host}/deklaracja-dostepnosci`}
            />
          </Helmet>
          <ConnectedRouter children={routes} history={history} />
          {ExEnv.canUseDOM ? <ReduxToastr /> : null}
        </div>
      </Provider>
    </AppContainer>,
    document.getElementById("root")
  );
}

renderApp(store, routes, history);

// Allow Hot Module Replacement
if (module.hot) {
  module.hot.accept("./routes", () => {
    routes = require("./routes").routes;
    renderApp(store, routes, history);
  });
}
